import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/namiwalks-2026")({
  beforeLoad: () => {
    throw redirect({ to: "/namiwalks" });
  },
});
